import { BookYearService } from "@/services";
import { BrowserInfo } from "./browser";

export interface IIframeOptions {
	useElectronServerAsProxy?:boolean;
}


export function processIframeUrl(url:string, options:IIframeOptions):string {
	url = resolveElectronUrl(url, options.useElectronServerAsProxy || false);
	url = url.replaceAll("{{bookyear}}", `${BookYearService.selectedBookYear}`);
	return url;
}


function resolveElectronUrl(url: string, useDesktopAppAsProxy: boolean = false): string {
	let result = url;
	if (BrowserInfo.getElectronUrl()) {
		let elUrl = new URL(BrowserInfo.getElectronUrl());
		result = result
			.replaceAll("{{electronUrl}}", elUrl.href)
			.replaceAll("{{electronPort}}", elUrl.port)
			.replaceAll("{{electronHost}}", elUrl.host)
			.replaceAll("{{electronHostname}}", elUrl.hostname);
		if (useDesktopAppAsProxy) {
			let parsed = new URL(result);
			parsed.protocol = "http";
			parsed.host = parsed.hostname + ".prx." + elUrl.host;
			result = parsed.href;
		}
	}
	return result;
}